module.exports = __webpack_public_path__ + "static/img/product13.39c9256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product13.png
// module id = mi+v
// module chunks = 13